import React from 'react';
import type {EncompassExternalOrganizationResponse} from '../../models/SubordinateCompany';

interface CustomRadioGroupProps {
  selectedSubordinate: string;
  setSelectedSubordinate: (value: string) => void;
  loanDataFields: any;
  setShowPopup: (value: boolean) => void;
  postSubOrdinateCompany: (payload: any) => Promise<EncompassExternalOrganizationResponse>; // Update the type here
  loanId?: string|null;
}

const CustomRadioGroup: React.FC<CustomRadioGroupProps> = ({
                                                             selectedSubordinate,
                                                             setSelectedSubordinate,
                                                             loanDataFields,
                                                             setShowPopup,
                                                             postSubOrdinateCompany,
                                                             loanId,
                                                           }) => {
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = event.target.value;

    if (
      (loanDataFields?.subordinateCompanyForJVA?.companyName !== null && loanDataFields?.subordinateCompanyForJVA?.companyName !== '') ||
      (loanDataFields?.subordinateCompanyForDBA?.companyName !== null && loanDataFields?.subordinateCompanyForDBA?.companyName !== '')
    ) {
      setShowPopup(true);
      return;
    }

    if (selectedValue === 'None') {
      const payload = {
        companyType: 'None',
        loanId: loanId,
        orgId: null,
        companyName: null,
        companyLegalName: null,
        address: null,
        phone: null,
      };
      postSubOrdinateCompany(payload).then(() => {
        console.log('Success: Posted subordinate company with None type');
      });
    }

    setSelectedSubordinate(selectedValue);
    setShowPopup(false);
  };

  return (
    <div className="subordinate-radiogroup">
      <p style={{fontWeight: 500, fontSize: '24px'}}>Subordinate Company</p>
      <p style={{fontSize: '18px', color: 'black'}}>
        Tell us the subordinate type and company selling this loan, if applicable.
      </p>
      <div style={{display: 'flex', flexDirection: 'row', gap: '30px', fontSize: "18px"}}>
        <div>
          <label>
            <input
              type="radio"
              name="subordinate"
              value="None"
              checked={selectedSubordinate === 'None'}
              onChange={handleRadioChange}
            />
            None
          </label>
        </div>
        <div>
          <label>
            <input
              type="radio"
              name="subordinate"
              value="encompassExternalOrganizationJV"
              checked={selectedSubordinate === 'encompassExternalOrganizationJV'}
              onChange={handleRadioChange}
            />
            Joint Ventures affiliate
          </label>
        </div>
        <div>
          <label>
            <input
              type="radio"
              name="subordinate"
              value="encompassExternalOrganizationDBA"
              checked={selectedSubordinate === 'encompassExternalOrganizationDBA'}
              onChange={handleRadioChange}
            />
            Doing business as
          </label>
        </div>
        </div>
      </div>
      );
      };

      export default CustomRadioGroup;
